const popoverMixin = {
  mounted() {
    // This enables closing a popover with Esc when it is triggered on hover
    document.addEventListener('keydown', this.closePopover)
  },
  unmounted() {
    document.removeEventListener('keydown', this.closePopover)
  },
  methods: {
    closePopover: function (e) {
      if (e.key === 'Escape') {
        const popover = document.getElementsByClassName('popover fade in')[0]
          if (popover) {
            e.stopImmediatePropagation()
            popover.remove()
          }
        }
    },
  }
}

  export default popoverMixin